/*----------------------
  SWIPER
---------------------- */
SwiperProductImages = {
    init: function () {
        const productSwiper = document.querySelector('.swiper-product-images-trenzar');
        if (!productSwiper) return;

        const nextEl = productSwiper.querySelector('.swiper-button-next');
        const prevEl = productSwiper.querySelector('.swiper-button-prev');

        let swiperInstance = productSwiper.swiper;

        if (!swiperInstance) {
            swiperInstance = new Swiper(productSwiper, {
                loop: false,
                navigation: {
                    nextEl: nextEl,
                    prevEl: prevEl,
                    disabledClass: 'swiper-button-disabled',
                },
                slidesPerView: 1,
                spaceBetween: 0,
                grabCursor: true,
                hashNavigation: {
                    watchState: true,
                },
                on: {
                    init: function() {
                        // Show/hide arrows as needed on init
                        if (prevEl) prevEl.style.display = this.isBeginning ? 'none' : 'block';
                        if (nextEl) nextEl.style.display = this.isEnd ? 'none' : 'block';
                    },
                    slideChange: function() {
                        // Show/hide arrows as needed on slide change
                        if (prevEl) prevEl.style.display = this.isBeginning ? 'none' : 'block';
                        if (nextEl) nextEl.style.display = this.isEnd ? 'none' : 'block';
                    }
                }
            });
        }

        if (window.MarlotProductGalleryVideo) {
            window.MarlotProductGalleryVideo.init(productSwiper, swiperInstance);
        }
    }
};

SwiperCarousel = {
    init: function () {
        var swiper = new Swiper(".swiper-carousel-trenzar", {
            slidesPerView: "auto",
            spaceBetween: 3,
        });
    }
};


SwiperMedia = {
    init: function () {
        var swiper = new Swiper(".swiper-media-trenzar", {
            slidesPerView: 1,
            grabCursor: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
                renderBullet: function (index, className) {
                    return '<span class="' + className + '">' + (index + 1) + "</span>";
                },
            },
        });
    }
};

/*----------------------
   ACCORDEON
---------------------- */
accordeon = {
    init: function () {
        const $body = $("body");
        const $accordeonItems = $(".product-trenzar__accordeon__item");
        const $accordeonTitles = $(".product-trenzar__accordeon__item__title");

        $accordeonTitles.on("click", function () {
            const $item = $(this).closest(".product-trenzar__accordeon__item");
            $accordeonItems.not($item).removeClass('open')
            $item.toggleClass("open");
        });

        $body.on("click", function (e) {
            if (!$(e.target).closest('.product-trenzar__accordeon__item__title, .product-trenzar__accordeon__item').length) {
                $accordeonItems.removeClass("open");
            }
        })

    }
};

/*----------------------
  GO TO
---------------------- */
GoTo = {
    init: function () {
        $(".trenzar-info__links a[href*='#']").on("click", function () {
            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    if ($(window).width() <= 992) {
                        $('html,body').animate({
                            scrollTop: target.offset().top - 58
                        }, 400);
                    }
                    else {
                        $('html,body').animate({
                            scrollTop: target.offset().top - 64
                        }, 400);
                    }


                    return false;
                }
            }
        });
    }
};


$(document).ready(function () {
    try {
        SwiperProductImages.init();
        SwiperCarousel.init();
        SwiperMedia.init();
        accordeon.init();
        GoTo.init();
    } catch (error) {
        console.warn('Error initializing components:', error);
    }
});
